import InnoIcons from "@InnoIcons/";
import { Tooltip } from "antd";
import TooltipText from "components/TooltipText";

const PointIdIndicatorInJournal = () => {
  return (
    <>
      {/* <span
        title="Point linked"
        style={{
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          backgroundColor: "#52c41a",
          display: "inline-block",
          marginRight: "5px",
        }}
      /> */}
      <Tooltip title="Knowledge Ingested" placement="right">
        <InnoIcons.CheckCircleIcon
          sx={{ color: "#52c41a", fontSize: "22px" }}
        />
      </Tooltip>
    </>
  );
};

export default PointIdIndicatorInJournal;
